import { useNavigate, useRouteError } from 'react-router';
import './index.scoped.scss';
import Windmill from '@components/_elements/Windmill/Windmill';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation, faHome } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@mui/material';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import useAlias from '@alias';

interface PageErrorProps {
  message?: string;
}

export default function PageError({ message }: PageErrorProps) {
  const alias = useAlias();
  const error = useRouteError();
  const navigate = useNavigate();
  const defaultMessage = alias('500 - Something went wrong');
  if (error !== undefined) {
    console.debug(error);
  }
  return (
    <div className='page-not-found'>
      <Windmill opacity='0.7' bottom='30px' left='20%' scale='1.2' />
      <Windmill opacity='0.5' bottom='-100px' left='15%' scale='0.6' />
      <div className='info'>
        <div className='first-line'>
          <FontAwesomeIcon icon={faCircleExclamation} />
        </div>
        <div className='second-line'>{message || defaultMessage}</div>
        <Button
          onClick={() => navigate('/home')}
          variant='outlined'
          color='inherit'
          startIcon={<FontAwesomeIcon icon={faHome} />}
          sx={{
            minHeight: 40,
            mt: 2,
          }}
        >
          <FormattedAlias id='Back to Home' />
        </Button>
      </div>
    </div>
  );
}

export function TechnicalWorks() {
  const alias = useAlias();
  return <PageError message={alias('Technical works...')} />;
}
export function PageNotFound() {
  const alias = useAlias();
  return <PageError message={alias('404 - Page not found')} />;
}
